import { fixtureBlocks } from '../demo/fixture';
import {
  type BlocoDo,
  type ConfigDoProduto,
  ESQUEMAS_DOS_PRODUTOS,
  IDS_DOS_PRODUTOS,
  type TemplateDoRelatorio,
} from '../types';

const templates: TemplateDoRelatorio[] = [
  {
    id: 'closing',
    title: 'Fechamento do mês',
    description: 'Uma visão completa para apresentar resultados.',
    prompt: 'Quero preparar o fechamento mensal.',
    blocks: ['overview', 'funnel', 'agreements', 'objections', 'handoffs', 'timing', 'actions'],
  },
  {
    id: 'agreements',
    title: 'Acordos e resultados',
    description: 'Conversão, valores negociados e oportunidades.',
    prompt: 'Quero analisar os acordos e os valores negociados.',
    blocks: ['overview', 'funnel', 'agreements', 'actions'],
  },
  {
    id: 'engagement',
    title: 'O que move as conversas?',
    description: 'Engajamento, objeções e pontos de atenção.',
    prompt: 'Quero entender o engajamento das negociações.',
    blocks: ['overview', 'funnel', 'objections', 'handoffs', 'timing', 'actions'],
  },
];

export const configDaNegociacao: ConfigDoProduto = {
  produto: 'negociacao',
  rota: '/negociacoes/relatorios',
  endpoint: '/relatorios/negociacao',
  prefixoDoArquivo: 'arbitralis-negociacao',
  blocos: IDS_DOS_PRODUTOS.negociacao.blocks,
  esquemas: ESQUEMAS_DOS_PRODUTOS.negociacao,
  blockLabels: {
    overview: 'Visão geral',
    funnel: 'Engajamento e conversão',
    agreements: 'Acordos e valores',
    objections: 'Objeções e encerramentos',
    handoffs: 'Atendimento humano',
    timing: 'Tempo e tentativas',
    actions: 'Próximos passos',
  } satisfies Record<BlocoDo<'negociacao'>, string>,
  templates,
  blocosDaDemonstracao: fixtureBlocks,
  defaultPreferences: { remember: true, focus: 'closing', blocks: templates[0].blocks },
  stages: [
    'Organizando seu pedido',
    'Consultando negociações',
    'Conferindo os indicadores',
    'Construindo os blocos',
    'Finalizando seu relatório',
  ],
  focoInicial: 'closing',
  blocoDoPrimeiroInsight: 'funnel',
  palavrasDoModelo: [
    { padrao: /acordo|valor|conversao/, foco: 'agreements' },
    { padrao: /engajamento|conversa|objec|humano|tentativa/, foco: 'engagement' },
    { padrao: /relatorio|dashboard|fechamento|resultado|negociac/, foco: 'closing' },
  ],
  textos: {
    origem: { rotulo: 'Negociações', href: '/negociacoes' },
    tituloPadrao: 'Fechamento de negociações',
    categoria: 'NEGOCIAÇÃO',
    semDados:
      'Não encontramos negociações elegíveis para este recorte. Experimente ampliar o período.',
    comecar: 'Começar com um fechamento',
    cabecalhoDoDocumento: 'Negociação · relatório personalizado',
    carteira: 'Sua carteira de negociações',
    cabecalhoDoPdf: 'NEGOCIAÇÃO · RELATÓRIO',
    resumoDaDemonstracao: (pedido) =>
      `Você quer um relatório de negociação com este foco: “${pedido}”. Vou organizar os indicadores nos blocos abaixo e considerar os detalhes que você trouxe. É isso que você precisa?`,
    foraDoEscopoDaDemonstracao:
      'Eu cuido de relatórios e dashboards de negociação. Posso analisar resultados, comparar recortes e explicar indicadores. O que você gostaria de entender sobre suas negociações?',
  },
};
